<template>
  <CustomDropdown
    :position="position"
    dropdownCSS="p-0"
    gap="5px"
    :relative-to-viewport="relativeToViewport"
  >
    <template #trigger>
      <div class="secondary_small gap-1">
        <ThemeImage
          class="size-4"
          :icon="imageNames.USERS_UNSELECTED"
          alt="dropdown_icon"
        />
        <span class="text-sm font-semibold">
          {{ label }}
        </span>
        <ThemeImage
          class="size-4"
          :icon="imageNames.DROPDOWN_GREY"
          alt="dropdown_icon"
        />
      </div>
    </template>

    <template #default>
      <div class="flex flex-col" :style="{ width: dropdownWidth }">
        <TabbedMultiSelectContent
          :tabs="computedTabs"
          :options="computedOptions"
          v-model="internalValue"
          :search-title="searchTitle"
          :search-placeholder="searchPlaceholder"
          :non-removable-items="nonRemovableItems"
          :enable-auto-select-current-user="enableAutoSelectCurrentUser"
          :initial-selection-by-tab="initialSelectionByTab"
          @selection-change="handleSelectionChange"
        />
      </div>
    </template>
  </CustomDropdown>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import CustomDropdown from "@/src/components/CustomDropdown.vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { imageNames } from "@/src/constants/imageConstants.js";
import TabbedMultiSelectContent from "@/src/components/view_components/TabbedMultiSelectContent.vue";

const props = defineProps({
  modelValue: { type: Array, default: () => [] },
  optionsByTab: { type: Object, default: () => ({ Users: [], Teams: [] }) },
  label: { type: String, default: "Add Users & Teams" },
  dropdownWidth: { type: String, default: "320px" },
  position: { type: String, default: "start" },
  relativeToViewport: { type: Boolean, default: false },
  searchTitle: { type: String, default: "Choose options" },
  searchPlaceholder: { type: String, default: "Search here" },
  nonRemovableItems: { type: Array, default: () => [] },
  enableAutoSelectCurrentUser: { type: Boolean, default: true },
  initialSelectionByTab: {
    type: Object,
    default: () => ({ users: [], teams: [] }),
  },
});

const emit = defineEmits(["update:modelValue", "selection-change"]);

const internalValue = ref([...props.modelValue]);
const isInternalUpdate = ref(false);
const selectionByTab = ref({ users: [], teams: [] });

const handleSelectionChange = (data) => {
  if (data.byTab) {
    selectionByTab.value = data.byTab;
  }
  emit("selection-change", data);
};

watch(
  () => props.modelValue,
  (val) => {
    if (isInternalUpdate.value) {
      isInternalUpdate.value = false;
      return;
    }
    internalValue.value = Array.isArray(val) ? [...val] : [];
  },
  { deep: true }
);

watch(
  internalValue,
  (val) => {
    isInternalUpdate.value = true;
    emit("update:modelValue", val);
    emit("selection-change", val);
  },
  { deep: true }
);

const computedTabs = computed(() => Object.keys(props.optionsByTab || {}));
const computedOptions = computed(() =>
  computedTabs.value.map((tab) => props.optionsByTab[tab] || [])
);
</script>

<style scoped></style>
